import { Button, Flex, Group, Modal, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useRef } from "react";

import type { ICol } from "../../../../interfaces";
import { useDispatch } from "../../../../redux/hooks";
import { addNewDynamicRow } from "../../../../redux/slices/generatorSlice";
import { clearValues } from "../../../utils/dynamicRows";
import { crumb } from "../../../../utils";

interface Props {
  sectionIndex: number;
  copyPrevVal: number | undefined;
}

const NmeaModal = ({ sectionIndex, copyPrevVal }: Props) => {
  const dispatch = useDispatch();
  const [opened, { close }] = useDisclosure();
  const nmeaCols = useRef<Record<string, ICol>>();
  const nmeaValues = useRef<Record<string, string>>();

  const insertNmeaValues = (obj: Record<string, any>) => {
    console.log("Inserting NMEA values into:", obj);
    const result = clearValues(obj, false, copyPrevVal);
    if (result && nmeaValues.current) {
      for (const [key, value] of Object.entries(result)) {
        if (value.NMEA) {
          let v: any = nmeaValues.current[value.NMEA];
          console.log("NMEA key:", key, "NMEA value:", v);
          if (value.unit === "temperature" || value.unit === "pressure") {
            v = {
              value: Number(v.replace(/[^\d.]/g, "")) || null,
              unit: value.unit === "temperature" ? "celsius" : "mbar",
            };
          }
          result[key] = { ...value, value: v };
        }
      }
    }
    return result;
  };

  const onNmeaModal = (withNmea: boolean) => () => {
    // Log NMEA row modal decision
    crumb("NMEA Row Modal: User decision", {
      accepted: withNmea,
      sectionIndex,
      copyPrevVal,
      hasNmeaData: !!nmeaValues.current,
      nmeaColumnsCount: nmeaCols.current ? Object.keys(nmeaCols.current).length : 0,
    });

    if (nmeaCols.current) {
      dispatch(
        addNewDynamicRow({
          row: {
            cols: withNmea
              ? insertNmeaValues(nmeaCols.current)
              : clearValues(nmeaCols.current, false, copyPrevVal, true), // Force full clear for manual entry
          },
          sectionIndex,
        }),
      );
    }
  };

  return (
    <Modal
      opened={opened}
      onClose={close}
      title="Automated Data"
      withCloseButton={false}
      yOffset="20dvh"
      size="lg">
      <Flex mx="auto" w="80%" mt="sm" direction="column" gap="md">
        <Text align="center">
          Automated data from the data provider has been received.
        </Text>
        <Text align="center">
          Please select Confirm if you would like this data populated or Decline
          if it has been manually populated.
        </Text>
      </Flex>
      <Group mt="lg" position="right">
        <Button onClick={onNmeaModal(false)} color="red">
          Decline
        </Button>
        <Button onClick={onNmeaModal(true)}>Confirm</Button>
      </Group>
    </Modal>
  );
};
export default NmeaModal;
